export default __webpack_public_path__ + "static/media/bg_comunication.5a3d0838.png";